import React from "react";
import { Box } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";
import { RouteConstants } from "../../../constants/route-constant";

interface ModuleBackButtonProps {
  size?: number;
}

const ModuleBackButton: React.FC<ModuleBackButtonProps> = ({ size = 30 }) => {
  const navigate = useNavigate();
  const iconSize = Math.round(size * 0.65);

  const handleClick = () => navigate(RouteConstants.ROUTE_HOME);

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleClick();
    }
  };

  return (
    <Box
      component='button'
      type='button'
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      aria-label='Back to home'
      style={{
        flexShrink: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: "#000",
        border: "none",
        cursor: "pointer",
        padding: 0,
        color: "#fff",
      }}
    >
      <IconArrowLeft size={iconSize} stroke={2.75} />
    </Box>
  );
};

export default ModuleBackButton;
